import './index.css'
export default function SkeltonLoader() {
  return <div id='ele-167' className="h-dvh flex flex-col justify-between items-center">
    <div id='ele-168' className='skeleton-loader'>
      <div id='ele-169' className="skeleton-header h-12 rounded-xl">
      </div>

      <div id='ele-170' className="left skeleton-text skeleton-title rounded-xl"></div>
      <div id='ele-171' className="left skeleton-text skeleton-subtitle rounded-xl"></div>
      <div id='ele-172' className="left skeleton-text skeleton-subtitle rounded-xl"></div>


      <div id='ele-173' className="right skeleton-text skeleton-subtitle rounded-xl mt-2"></div>
      <div id='ele-174' className="right skeleton-text skeleton-subtitle rounded-xl"></div>

      <div id='ele-175' className="left skeleton-text skeleton-title rounded-xl"></div>


      <div id='ele-176' className="right skeleton-text skeleton-subtitle rounded-xl mt-2"></div>
      <div id='ele-177' className="right skeleton-text skeleton-subtitle rounded-xl"></div>
      <div id='ele-178' className="right skeleton-text skeleton-title rounded-xl"></div>
    </div>

    <div id='ele-179' className='skeleton-loader'>
      <div id='ele-180' className="skeleton-input rounded-xl h-12 mt-auto">
        <div id='ele-181' className="skeleton-input-box rounded-xl"></div>
      </div>
    </div>

  </div>

}